// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';

import { TabLoader, TabConfig, addTab, removeAll } from 'wdna-components/lib/tabs';

const Installers: React.LazyExoticComponent<any> = React.lazy(() => import('../components/dashboard/Installers'));

export default class Loader extends TabLoader {
  /* Override tab loader method */
  public loadTab = (tabId?: string | number): void => {
    const access: boolean = true;
    if (access) {
      window.store.dispatch(removeAll());

      const tabData: TabConfig = {
        id: String(tabId || window.getStr()),
        title: 'Management | Installers',
        active: true,
        component: Installers,
        props: {
          report: 'MANAGEMENT_INSTALLERS',
          title: 'Installers',
        },
      };

      window.store.dispatch(addTab(tabData));
    }
  };
}
